import LoginView from './views/LoginView.vue'
import ProductDetailView from './views/ProductDetailView.vue'
import CheckoutSuccessModal from './views/CheckoutSuccessModal.vue'
import CheckoutConfirmationModal from './views/CheckoutConfirmationModal.vue'
import RestaurantInfoModal from './views/RestaurantInfoModal.vue'
import PostcodePickerModal from './components/PostcodePickerModal.vue'
import HotDeliveryLocationMapModal from './components/hotdelivery/LocationMapModal.vue'
import EnquiryModal from './components/EnquiryModal.vue'
import CartDropdown from './components/CartDropdown.vue'
import ClearCartModal from './components/ClearCartModal.vue'

export const modals = [
  {
    name: 'login',
    component: LoginView
  },
  {
    name: 'product-detail-view',
    component: ProductDetailView
  },
  {
    name: 'checkout-confirmation-modal',
    component: CheckoutConfirmationModal
  },
  {
    name: 'checkout-success',
    component: CheckoutSuccessModal
  },
  {
    name: 'restaurant-info-modal',
    component: RestaurantInfoModal
  },
  {
    name: 'hot-delivery-location-map',
    component: HotDeliveryLocationMapModal
  },
  {
    name: 'enquiry',
    component: EnquiryModal
  },
  {
    container: 'nav-dropdown',
    name: 'cart-dropdown',
    component: CartDropdown
  },
  {
    container: 'clear-cart',
    component: ClearCartModal
  },
  {
    name: 'postcode-picker',
    component: PostcodePickerModal
  }
]



// WEBPACK FOOTER //
// ./src/modals.js